import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { TabButtons, TabHealthera } from '../../healtheraComponents';
import { getOrgType, getTabValueForOrgType } from '../../helpers';
import useLocationQuery from '../../hooks/useQuery';
import {
  changeType,
  getOrganisationCountsByType,
} from '../../redux/organisations';

const OrgTypesTabs = () => {
  const {
    organisationCounts: {
      activeOrgActiveSites,
      activeOrgInactiveSites,
      activeOrgNoSites,
      inactive,
      actionNeeded,
      paymentOverdue,
    } = {},
    type: reduxOrganisationType,
  } = useSelector((state) => state.organisations);

  const history = useHistory();
  const dispatch = useDispatch();
  const { query, changeLocationQuery } = useLocationQuery();

  const handleTabChange = (_, value) => {
    const encodedValue = getOrgType(value);
    dispatch(changeType(encodedValue));
    if (history.location.pathname === '/organisations') {
      changeLocationQuery({ type: encodedValue });
    } else {
      history.push(`/organisations?type=${encodedValue}`);
    }
  };

  useEffect(() => {
    if (!query.search && !activeOrgActiveSites) {
      dispatch(getOrganisationCountsByType({}));
    }
  }, [dispatch, activeOrgActiveSites, query]);

  return (
    <TabButtons
      height={`64px`}
      value={getTabValueForOrgType(
        query.type || reduxOrganisationType || 'active',
      )}
      onChange={handleTabChange}
    >
      <TabHealthera disableRipple label={`Active, active site(s) (${activeOrgActiveSites})`} />
      <TabHealthera disableRipple label={`Active, inactive site(s) (${activeOrgInactiveSites})`} />
      <TabHealthera disableRipple label={`Active no sites (${activeOrgNoSites})`} />
      <TabHealthera disableRipple label={`Action Needed (${actionNeeded})`} />
      <TabHealthera disableRipple label={`Inactive (${inactive})`} />
      <TabHealthera
        disableRipple
        label={`Payment Overdue (${paymentOverdue})`}
      />
    </TabButtons>
  );
};

export default OrgTypesTabs;
